import cls from 'classnames';

import { IToolData, IBottomLink } from '../../../../../data/tools/types';
import NavSubmenuItem from '../NavSubmenuItem';
import BottomLinks from '../BottomLinks';

import useStyles from './styles';

type DropdownSubmenuProps = {
  links: IToolData[];
  visibleSubmenu: string;
  bottomLinks?: IBottomLink[];
};

const MAX_ITEMS_ON_COL = 7;

const getCols = function (len: number) {
  let columns = 1;

  if (len > MAX_ITEMS_ON_COL) {
    columns = Math.floor(len / MAX_ITEMS_ON_COL) + 1;
  }

  return `repeat(${columns}, 1fr)`;
};

const getRows = function (len: number) {
  let rows = MAX_ITEMS_ON_COL;

  if (len < MAX_ITEMS_ON_COL) {
    rows = len;
  }

  return `repeat(${rows}, 1fr)`;
};

function DropdownSubmenu({ links, visibleSubmenu }: DropdownSubmenuProps) {
  const classes = useStyles();

  return (
    <div className={cls(classes.root, visibleSubmenu && classes.visible)}>
      {links.map((link) => {
        const { subCategories, bottomLinks, id } = link;

        if (!subCategories) {
          return null;
        }

        const { length: subcategoriesLength } = subCategories;
        const bottomLinksLength = bottomLinks?.length || 0;
        const isVisible = link.id === visibleSubmenu;
        const length = subcategoriesLength + bottomLinksLength;

        return (
          <div key={id} className={cls(classes.container, isVisible && classes.visible)}>
            <ul
              className={classes.list}
              style={{
                gridTemplateColumns: getCols(length),
                gridTemplateRows: getRows(length),
              }}
            >
              {subCategories.map(({ label, id: key, href, openInNewTab }) => (
                <NavSubmenuItem key={key} label={label} href={href} openInNewTab={openInNewTab} />
              ))}
            </ul>
            {bottomLinks && (
              <div className={classes.bottomLinks}>
                <BottomLinks links={bottomLinks} />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default DropdownSubmenu;
